import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../../Services/styleAllServices.css"; 

// Import relevant images - adjust paths as needed
import fertilizerApplication from "../../../../assets/img/lawn-maintenance-fertilizer-spreader.jpg";
import healthyTurf from "../../../../assets/img/lawn-health.jpg";
import burhanTeam from "../../../../assets/img/burhan-team.jpg"; 
import vibrantGreenLawn from "../../../../assets/img/synthetic-fertilizer-in-hand.jpg"; 

export default function NorthVancouverLawnFertilizing() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Update canonical URL
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }

    // TITLE - Optimized for "Lawn Fertilizing North Vancouver" (Service + Location format)
    const newTitle = "Lawn Fertilizing North Vancouver | Professional Fertilization | BUR-HAN";
    document.title = newTitle;

    // META DESCRIPTION - Compelling with keywords and benefits
    const newDescription = "Professional lawn fertilizing North Vancouver. Custom fertilization programs for lush, green, healthy grass. Synthetic & organic options. Free lawn assessment & quote: 604-983-2687";
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      descriptionMetaTag = document.createElement("meta");
      descriptionMetaTag.setAttribute("name", "description");
      descriptionMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(descriptionMetaTag);
    }

    // KEYWORDS - Comprehensive North Vancouver fertilizing keywords
    const newKeywords = [
      "lawn fertilizing North Vancouver",
      "lawn fertilization North Vancouver",
      "grass fertilizing North Vancouver",
      "lawn care North Vancouver",
      "fertilizer service North Vancouver",
      "lawn treatment North Vancouver",
      "grass feeding North Vancouver",
      "turf nutrition North Vancouver",
      "lawn fertilizer North Vancouver",
      "residential lawn fertilizing North Vancouver",
      "commercial lawn fertilizing North Vancouver",
      "spring lawn fertilizing North Vancouver",
      "fall lawn fertilizing North Vancouver",
      "best lawn fertilizer North Vancouver",
      "lawn fertilizing near me North Vancouver"
    ].join(", ");
    
    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      keywordsMetaTag = document.createElement("meta");
      keywordsMetaTag.setAttribute("name", "keywords");
      keywordsMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(keywordsMetaTag);
    }

    // GEO META TAGS - North Vancouver specific
    let geoTag = document.querySelector('meta[name="geo.placename"]');
    if (geoTag) {
      geoTag.setAttribute("content", "North Vancouver, British Columbia");
    } else {
      geoTag = document.createElement("meta");
      geoTag.setAttribute("name", "geo.placename");
      geoTag.setAttribute("content", "North Vancouver, British Columbia");
      document.head.appendChild(geoTag);
    }

    // OPEN GRAPH TAGS
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      ogTitleTag = document.createElement("meta");
      ogTitleTag.setAttribute("property", "og:title");
      ogTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(ogTitleTag);
    }

    let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      ogDescriptionTag = document.createElement("meta");
      ogDescriptionTag.setAttribute("property", "og:description");
      ogDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(ogDescriptionTag);
    }

    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute("content", canonicalUrl);
    } else {
      ogUrlTag = document.createElement("meta");
      ogUrlTag.setAttribute("property", "og:url");
      ogUrlTag.setAttribute("content", canonicalUrl);
      document.head.appendChild(ogUrlTag);
    }

    // TWITTER CARDS
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", newTitle);
    } else {
      twitterTitle = document.createElement("meta");
      twitterTitle.setAttribute("name", "twitter:title");
      twitterTitle.setAttribute("content", newTitle);
      document.head.appendChild(twitterTitle);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", newDescription);
    } else {
      twitterDescription = document.createElement("meta");
      twitterDescription.setAttribute("name", "twitter:description");
      twitterDescription.setAttribute("content", newDescription);
      document.head.appendChild(twitterDescription);
    }

  }, [location.pathname]);

  // Schema markup for Lawn Fertilizing North Vancouver
  useEffect(() => {
    const schemaScript = document.createElement("script");
    schemaScript.setAttribute("type", "application/ld+json");
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",  // CHANGED from "Service" to "LocalBusiness"
      "@id": "https://bur-han.ca/north-vancouver-lawn-fertilizing",
      "name": "BUR-HAN Garden & Lawn Care - Lawn Fertilizing North Vancouver",
      "description": "Professional lawn fertilizing services in North Vancouver. Customized fertilization programs for lush, green, healthy lawns. Synthetic and organic options available.",
      "url": "https://bur-han.ca/north-vancouver-lawn-fertilizing",
      "telephone": "+1-604-983-2687",
      "email": "gardenandlawncare@bur-han.ca",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2323 Old Dollarton Rd Unit A",
        "addressLocality": "North Vancouver",
        "addressRegion": "BC",
        "postalCode": "V7H 1A9",
        "addressCountry": "CA"
      },
      "areaServed": {
        "@type": "City",
        "name": "North Vancouver"
      },
      "openingHours": [
        "Monday-Friday 07:00-18:00",
        "Saturday 08:00-16:00"
      ],
      "sameAs": [
        "https://www.facebook.com/burhanlandscaping",
        "https://www.instagram.com/burhanlandscaping"
      ],
      "makesOffer": [  // CHANGED from "offers" to "makesOffer"
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Residential Lawn Fertilizing North Vancouver",
            "description": "Custom fertilization programs for residential lawns in North Vancouver",
            "areaServed": "North Vancouver"
          },
          "availability": "https://schema.org/InStock"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Commercial Lawn Fertilizing North Vancouver",
            "description": "Custom fertilization programs for commercial properties in North Vancouver",
            "areaServed": "North Vancouver"
          },
          "availability": "https://schema.org/InStock"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Organic Lawn Fertilizing North Vancouver",
            "description": "Eco-friendly organic fertilization for North Vancouver lawns",
            "areaServed": "North Vancouver"
          },
          "availability": "https://schema.org/InStock"
        }
      ]
    });
    
    const existingSchema = document.querySelector('script[data-schema="north-vancouver-fertilizing"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    schemaScript.setAttribute("data-schema", "north-vancouver-fertilizing");
    document.head.appendChild(schemaScript);
  }, []);
  

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        {/* H1 - Optimized with primary keyword first */}
        <h1 data-aos="zoom-in">Lawn Fertilizing North Vancouver </h1>
        <div className="organic-badge" data-aos="fade-up">
          <span>Customized Programs for Every Lawn</span>
        </div>
      </div>
      <div className="serviceItemsMain">
        <section id="about" className="about">
          <h2
            data-aos="fade-down"
            style={{
              margin: "2vw",
              textAlign: "center",
              fontSize: "2vw",
              textTransform: "uppercase",
            }}
          >
            "Nourishing your lawn for vibrant health and resilience"
          </h2>
          <hr />
          <div className="row writtenContent">
            <div
              className="col-lg-6 order-1 order-lg-2 px-5"
              data-aos="fade-left"
            >
              <img loading="lazy"
                src={burhanTeam}
                alt="BUR-HAN technician inspecting lawn for fertilization plan"
                className="img-fluid bhTeam"
              />
            </div>
            <div
              className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
              data-aos="fade-right"
            >
              <div className="corner-left">
                <div className="title" data-aos="zoom-in">
                  <h3>BUR-HAN GARDEN & LAWN CARE</h3>
                </div>
                <div
                  className="aboutSentence"
                  data-aos="fade-right"
                  data-duration="2000"
                >
                  <p>
                    BUR-HAN Garden & Lawn Care has been providing Residential & Commercial landscaping services for over 30 years.{" "}
                    <a href="/our-projects" className="internal-link">
                      View our completed landscaping projects here.
                    </a>{" "}
                    North Vancouver's high annual rainfall leaches nutrients from soil quickly, making regular professional fertilization essential for maintaining a healthy, green lawn. BUR-HAN's custom fertilization programs are calibrated for North Shore soil profiles, replenishing nitrogen and other key nutrients that heavy rain washes away, and supporting strong, disease-resistant turf across North Vancouver properties throughout the growing season.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="banner-section">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <h3
                  className="heading"
                  data-aos="fade-right"
                  style={{ textTransform: "uppercase" }}
                >
                  "The right nutrients for a <span>perfect lawn</span>"
                </h3>
              </div>
              <div
                className="col-lg-6 col-md-12 col-sm-12"
                data-aos="fade-left"
              >
                <p className="text">
                  "From lush green vibrancy to enhanced drought resistance, professional fertilization is key to a truly thriving lawn."
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy"
              src={fertilizerApplication}
              alt="Professional applying fertilizer to a lawn"
              title="Expert Lawn Fertilization Application"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <span className="caption d-block mb-2 font-weight-bold">
              BUR-HAN's Comprehensive Approach
            </span>
            <h3 className="headingImageText text-uppercase">
            How Our Synthetic Fertilization Works
            </h3>
            <p className="mb-3">
              Our advanced synthetic fertilization program is designed to deliver precise nutrients while supporting your lawn's natural vitality:
            </p>
            <ul>
              <li>
                <strong>Efficient Nutrient Uptake:</strong> Our synthetic formulas provide readily available nitrogen, phosphorus, and potassium, optimized for quick absorption by your lawn.
              </li>
              <li>
                <strong>pH Optimization:</strong> While synthetic, our tailored applications include agents to help maintain an ideal soil pH, essential for nutrient accessibility and overall plant health.
              </li>
              <li>
                <strong>Microbial Support:</strong> Our program strategically enhances conditions that encourage beneficial microbial activity, contributing to a healthy soil environment.
              </li>
              <li>
                <strong>Enhanced Root Development:</strong> By providing balanced and accessible nutrients, our synthetic fertilization stimulates significant root proliferation, promoting a stronger and more resilient turf.
              </li>
            </ul>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Benefits of Professional Lawn Fertilization
            </h3>
            <ul>
             <li>
                <strong>Precise Nutrient Delivery:</strong> Our synthetic formulas are engineered for targeted nutrient release, minimizing waste and supporting turf health efficiently.
              </li>
              <li>
                <strong>Enhanced Green Color:</strong> Achieve a vibrant, consistent green that enhances your property's curb appeal.
              </li>
              <li>
                <strong>Stronger, Denser Turf:</strong> Fertilized lawns develop a thicker, more resilient turf that naturally resists weeds and diseases such as european chafer beetle.
              </li>
              <li>
                <strong>Improved Drought & Stress Resistance:</strong> Healthy roots grow deeper, allowing your lawn to better withstand dry spells and environmental pressures.
              </li>
              <li>
                <strong>Long-Term Soil Health (supported by proper nutrient management):</strong> Our programs contribute to a balanced soil nutrient profile, which supports healthy turf and its surrounding ecosystem.
              </li>
            </ul>
            <p>
              Invest in professional fertilization to transform your lawn into a beautiful, robust outdoor space.
            </p>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy"
              src={vibrantGreenLawn} // New image for benefits
              alt="Lush, vibrant green lawn after professional fertilization"
              title="Benefits of professional lawn care"
            />
          </div>
        </section>
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy"
              src={healthyTurf}
              alt="Lawn cross-section showing healthy root system"
              title="The science behind effective lawn fertilization"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <span className="caption d-block font-weight-bold">
              Expertise & Precision
            </span>
            <h3 className="headingImageText text-uppercase">
              How BUR-HAN Fertilization Works
            </h3>
            <p className="mb-3">
              Our scientifically-backed approach ensures your lawn receives exactly what it needs, when it needs it:
            </p>
            <ul>
              <li>
                <strong>Ongoing Monitoring & Program Adjustment:</strong> We continuously observe your lawn's response and make necessary adjustments to optimize its health and appearance.
              </li>
              <li>
                <strong>Balanced Nutrient Delivery:</strong> Applying macro and micronutrients essential for turf health, including Nitrogen (N) for growth, Phosphorus (P) for root development, and Potassium (K) for overall vigor.
              </li>
              <li>
                <strong>Slow-Release Formulations:</strong> We often use slow-release fertilizers (both synthetic and conventional) to provide a consistent nutrient supply, preventing surges and promoting steady growth.
              </li>
              <li>
                <strong>Expert Application Techniques:</strong> Our technicians use calibrated equipment for even distribution, ensuring every part of your lawn benefits.
              </li>
            </ul>
          </div>
        </section>



        <section className="how-it-works" data-aos="fade-up">
          <div className="container py-4 px-5">
            <h3 className="headingImageText text-uppercase mb-4">How Our North Vancouver Lawn Fertilizing Service Works</h3>
            <div className="steps-grid">
              <div className="step-item">
                <span className="step-number">1</span>
                <h4>Lawn & Soil Assessment</h4>
                <p>Before applying any product, we evaluate your North Vancouver lawn's current condition — colour, density, weed pressure, and signs of nutrient deficiency. This guides the right fertilizer formula and application rate for your property.</p>
              </div>
              <div className="step-item">
                <span className="step-number">2</span>
                <h4>Targeted Application</h4>
                <p>We apply the right fertilizer for the season — higher nitrogen in spring to promote growth, balanced blends in summer, and potassium-rich formulas in fall to harden the grass before North Vancouver's wet winter season. Every application is precise and even.</p>
              </div>
              <div className="step-item">
                <span className="step-number">3</span>
                <h4>Ongoing Program Management</h4>
                <p>A single application isn't enough. BUR-HAN manages your full seasonal fertilization schedule — 4 to 5 applications per year — so your North Vancouver lawn receives consistent nutrition at the right times without you having to track it yourself.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Lawn Care Services in North Vancouver</h2>
          <div className="lawnCareLinks-grid">
      <a href="/lawn-mowing-north-vancouver">
        <strong>Lawn Mowing North Vancouver</strong>
        <span>Weekly electric mowing service</span>
      </a>
      <a href="/lawn-aeration-north-vancouver">
        <strong>Lawn Aeration North Vancouver</strong>
        <span>Core aeration for healthier roots</span>
      </a>
      <a href="/landscaping-north-vancouver">
        <strong>Landscaping North Vancouver</strong>
        <span>Full-service landscape maintenance</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready for a healthier, more beautiful lawn?</h3>
                <p>
                  Our Lawn Care Specialists are ready to assess your property and
                  recommend the perfect fertilization schedule tailored to your specific
                  lawn and goals.
                </p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}